module.exports = __webpack_public_path__ + "static/img/pic_etcpr_kcpx@2x.c5bd2c3b.png";